<div class="box_default box_white custom_form">
  <div *ngIf="status == STATUS_DONE else formLoading"  class="box_main">
      <div class="box_item" [ngClass]="{'invalid-form': currentForm.form.name == ''}">
        <label class="box-label h3-type">NAME THIS FORM</label>
        <div [ngClass]="{'invalid-field': currentForm.form.name == ''}">
          <input type="text" [ngModel]="currentForm.form.name" [placeholder]="'Start by giving the form a name that is clear and descriptive'" (ngModelChange)="onFormNameChange($event)">
        </div>
      </div>
      <div class="form-specifications">
       <header>
        <h3>ADD YOUR FIELDS</h3>
       </header> 
        <div class="button-settings-add">
          <core-helpers-navigation-three-dots-menu
            [menu]="menuFields"
            (action)="onMainMenuClick($event)"
          ></core-helpers-navigation-three-dots-menu>
        </div>
        <ng-container *ngIf="currentFields && currentFields.length > 0; else noFieldsYet " >
          <div class="form-fields" cdkDropList (cdkDropListDropped)="drop($event)">
            <ul class="fields-list">
            <!-- place in the li the new component for form  dynamic fields where each field will be loaded in html -->
            <!-- we can use this in the li inactive [ngClass]="{'removed-field': !field.active}"  [hidden]="!field.active"-->
              <li class="fields-list-item" [hidden]="!field.active"
                *ngFor="let field of currentFields  | sortBy : 'position' : 'asc'; trackBy: trackByFn " 
                cdkDrag [cdkDragData]="field">
                <!-- <span> POS: {{field.position}} </span> -->
                <span cdkDragHandle class="field-drag-handle"></span>
                <app-settings-custom-forms-dynamic-field-host 
                  [field]="field"
                  (menuClick)="onFieldMenuClick($event)"
                  (fieldChange)="onFieldChange($event)"
                ></app-settings-custom-forms-dynamic-field-host>
                <!-- <ng-container *ngIf="!isFieldTypeValid(field.type)> -->

                <!-- </ng-container> -->
                <!-- Keep this code in case we want to let user clean old fields with a discrd button -->
                <!-- <ng-template #deprecatedField>
                  <p> {{field.type}} is deprecated </p>
                  <core-helpers-forms-button-white [text]="'Remove Forever'" (click)= "onDiscard(field)"></core-helpers-forms-button-white>
                </ng-template> -->
              </li>
            </ul>
          </div>
        </ng-container>
        <ng-template #noFieldsYet>
          <div class="empty-fields">
            <core-helpers-box-alert-message-icon
              [text]="'There are currently no fields on this form, you can add one now.'"
              [icon]="''"
            ></core-helpers-box-alert-message-icon>
          </div>
        </ng-template>
        <div class="box_fieldset">
          <core-helpers-forms-button-white [disabled]="!changesPending || !fieldsReady || buttonDisabled" [text]="'Save'" (click)= "onSubmit()"></core-helpers-forms-button-white>
          <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
        </div>
      </div>
  </div>
  <ng-template #formLoading>
    <div class="loader">
      <div class="dimmed" >
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
        </div>
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>